<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/plan-summary', text: 'addGrades_title' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'addGrades_title' | translate}}</h1>
    </header>

    <form #form="ngForm" [class.was-validated]="submitted" *ngIf="data">
        <div class="row">
            <div class="data-value col-sm">
                <label>{{'addGrades_lblSpeciality' | translate}}</label>
                <div>{{data.SpecialityName}}</div>
            </div>

            <div class="data-value col-sm">
                <label>{{'addGrades_lblCourse' | translate}}</label>
                <div>{{data.SubjectName}}, {{data.SubjectCode}}</div>
            </div>

            <div class="data-value col-sm">
                <label>{{'addGrades_lblResident' | translate}}</label>
                <div>{{data.StudentName}} {{data.StudentSurname}}</div>
            </div>
        </div>

        <app-table [rows]="rows" [columns]="columns">
            <ng-template #rowTemplate let-row>
                <tr>
                    <td class="hidden-md-down">
                        <div class="kind">
                            <span class="kind-bubble"
                                  [class.bg-success]="row.Kind == 'Final'"
                                  [class.bg-secondary]="row.Kind == 'Intermediate'"></span>
                            {{'addGrades_kind' + row.Kind | translate}}
                        </div>
                    </td>
                    <td class="hidden-sm-down text-nowrap">
                        <div>
                            {{getPeriodDisplay(row.StudyYear, row.SubjectSemester)}}
                        </div>
                        <div *ngIf="row.RotationId" class="text-sub">
                            ({{row.RotationDateFrom | appDate}} - {{row.RotationDateTo | appDate}})
                        </div>
                    </td>
                    <td class="hidden-sm-down">{{row.TypeName}}</td>
                    <td>
                        <span class="grade-badge hidden-lg-up"
                              [ngbTooltip]="'addGrades_kind' + row.Kind | translate"
                              [class.border-success]="row.Kind == 'Final'"
                              [class.border-secondary]="row.Kind == 'Intermediate'">
                            {{row.GradeName}}
                        </span>
                        <div class="hidden-md-down text-nowrap">{{row.GradeName}}</div>
                        <div class="hidden-md-up">
                            <i class="fi fi-rs-user"></i>
                            {{row.LecturerName}} {{row.LecturerSurname}}
                        </div>
                        <div class="text-mute hidden-md-up">{{getPeriodDisplay(row.StudyYear, row.SubjectSemester)}}</div>
                        <div *ngIf="row.RotationId" class="text-mute hidden-md-up">
                            ({{row.RotationDateFrom | appDate}} - {{row.RotationDateTo | appDate}})
                        </div>
                    </td>
                    <td class="hidden-sm-down">{{row.LecturerName}} {{row.LecturerSurname}}</td>
                    <td>
                        <div class="table-actions">
                            <button type="button" *ngIf="canDelete" (click)="delete(row)" class="btn btn-outline btn-icon"
                                    [ngbTooltip]="'delete' | translate">
                                <i class="fi fi-rs-trash"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </app-table>

        <section class="block">
            <h5>{{'addGrades_addGrade' | translate}}</h5>

            <div class="row">
                <div class="form-field col-sm-6 required">
                    <label class="form-label">{{'addGrades_lblKind' | translate}}</label>
                    <app-select [options]="gradeKinds"
                                [(ngModel)]="model.kind"
                                [required]="true"
                                [displayFn]="gradeKindDisplayFn"
                                (selectionChange)="onKindChange($event)"
                                name="kind">
                    </app-select>
                </div>

                
                <div class="form-field col-sm-6 required" *ngIf="model.kind">
                    <label class="form-label">{{'addGrades_lblYearSemester' | translate}}</label>
                    <app-select [options]="periods"
                                [(ngModel)]="model.period"
                                [required]="true"
                                [displayFn]="periodDisplayFn"
                                (selectionChange)="onPeriodChange($event)"
                                name="period">
                    </app-select>
                </div>
            </div>

            <div class="row" *ngIf="model.kind">
                <div class="form-field col-sm-6 required" *ngIf="model.kind == 'Intermediate'">
                    <label class="form-label">{{'addGrades_lblRotation' | translate}}</label>
                    <app-select [options]="model.rotations"
                                [(ngModel)]="model.rotationId"
                                [required]="true"
                                [displayFn]="rotationDisplayFn"
                                [valueProperty]="'Id'"
                                (selectionChange)="onRotationChange($event)"
                                name="rotationId">
                    </app-select>
                </div>

                <div class="form-field col-sm-6 required">
                    <label class="form-label">{{'addGrades_lblLecturer' | translate}}</label>
                    <app-select [options]="model.lecturers"
                                [(ngModel)]="model.lecturerId"
                                [required]="true"
                                [displayFn]="lecturerDisplayFn"
                                [valueProperty]="'Id'"
                                [disabled]="!model.period"
                                (selectionChange)="onLecturerChange($event)"
                                name="lecturerId">
                    </app-select>
                </div>
            </div>

            <ng-container *ngIf="model.kind">
                <hr class="mb-4" />

                <div class="row" *ngFor="let g of model.grades; let i = index">
                    <div class="col-sm form-field required">
                        <label class="form-label">{{g.typeName}}</label>
                        <app-select [options]="g.gradeOptions"
                                    [(ngModel)]="g.gradeId"
                                    [required]="true"
                                    [displayProperty]="'Name'"
                                    [valueProperty]="'Id'"
                                    name="grade{{i}}">
                        </app-select>
                        <div class="feedback" *ngIf="g.previous">
                            {{'addGrades_lastGrade' | translate}}: <strong>{{g.previous.GradeName}}</strong>
                            <ng-container *ngIf="g.isObsolete"> ({{'addGrades_lastGradeObsolete' | translate}})</ng-container>
                        </div>
                    </div>

                    <div class="form-field col-sm required">
                        <label class="form-label">{{'addGrades_lblReason' | translate}}</label>
                        <app-select [options]="g.reasonOptions"
                                    [(ngModel)]="g.reasonId"
                                    [required]="true"
                                    [displayProperty]="'Name'"
                                    [valueProperty]="'Id'"
                                    name="reason{{i}}">
                        </app-select>
                    </div>
                </div>
            </ng-container>

            <div class="form-actions">
                <div class="form-actions-group">
                    <button class="btn btn-outline" type="button" [routerLink]="['/'] | localize">
                        {{'addGrades_btnCancel' | translate}}
                    </button>

                    <button class="btn btn-primary" type="button" (click)="save()">
                        {{'addGrades_btnSave' | translate}}
                    </button>
                </div>
            </div>
        </section>
    </form>
</div>
